export enum BonusType {
  SIGNUP = 'SIGNUP',
  DEPOSIT = 'DEPOSIT',
  APP_INSTALLED = 'APP_INSTALLED',
  PUSH_ACCEPTANCE = 'PUSH_ACCEPTANCE',
}

export enum AmountType {
  FIXED = 'FIXED',
  PERCENTAGE = 'PERCENTAGE',
}

export interface IBonus {
  id: string;
  start: Date;
  end: Date;
  amount: number;
  type: BonusType;
  amountType: AmountType;
  addToCredit: boolean;
  minimumDepositUSD?: number;
  maximumDepositUSD?: number;
  maximumAmountUSD?: number;
  ftdOnly: boolean | null;
  methods: Array<string>;
}

export interface ICreateUpdateModalProps {
  show: boolean;
  hideModal: (refetch?: boolean) => void;
  currentBonus: IBonus | null;
}
